
import { useAuthStore } from 'src/auth/auth.store';
import { UNAUTHENTICATED_TOKEN } from 'src/config-global';
import { httpResponseHandler } from 'src/http/http-response-handler';

import { EventItem } from 'src/types/analytics/event';

import { HttpTypes } from '../../http';

export class AnalyticsRepository {
  constructor(private api: HttpTypes.HttpClient) { }

  async sendLog(logs: any[]) {
    const request: HttpTypes.HttpRequest = {
      url: 'analytics/logs/sendLogsToQueue',
      method: 'post',
      body: logs
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async sendManyEvents(events: EventItem[]) {
    const request: HttpTypes.HttpRequest = {
      url: 'analytics/events/many',
      method: 'post',
      body: { logs: events }
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async sendInstantEvent(events: EventItem[]) {

    const { accessToken } = useAuthStore.getState()

    const request: HttpTypes.HttpRequest = {
      url: 'analytics/events/many',
      method: 'post',
      body: { logs: events },
      headers: accessToken ? {} : {
        Authorization: `Bearer ${UNAUTHENTICATED_TOKEN}`
      }
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async linkUser(deviceId?: string) {
    const request: HttpTypes.HttpRequest = {
      url: 'analytics/lp-device/link-user',
      method: 'post',
      body: { deviceId },
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
